<template>
<div class="chapter">
<div class="inner_page">
<div class="fb-title1"><a id="page_xvii"></a><a id="page_xvi"></a><a href="#/contents#toc4" id="toc4a"><span style="color:#000000;">PREFACE</span></a></div>
<div class="noindent"><span class="dropcap">T</span>his work draws in part on our published books and articles, including those we authored individually or jointly. All the material, however, has been reworked to provide a unified presentation of a position we have developed over many years.</div>
<div class="indent">Here are our sources:</div>
<div class="indent">Cahn, Steven M. <i>A New Introduction to Philosophy</i>. New York: Harper &amp; Row, 1971. Reprinted in 2004 by Wipf &amp; Stock Publishers.</div>
<div class="indent">——. <i>Education and the Democratic Ideal.</i> Chicago: Nelson-Hall, 1979. Reprinted in 2004 by Wipf &amp; Stock Publishers.</div>
<div class="indent">——. <i>God, Reason, and Religion</i>. Belmont, Calif.: Thomson/ Wadworth, 2006.</div>
<div class="indent">——. <i>Puzzles &amp; Perplexities</i>. 2nd edition. Lanham, Md: Lexington Books, 2007. </div>
<div class="indent">Vitrano, Christine. <i>The Nature and Value of Happiness</i>. Boulder, Colo.: Westview Press, 2014.</div>
<div class="indent">——. “The Happy Immoralist.” In <i>A Teacher</i>’<i>s Life: Essays for Steven M. Cahn</i>, edited by Robert B. Talisse and Maureen Eckert, 149–53. Lanham, Md.: Lexington Books, 2009.</div>
<div class="indent"><a id="page_xviii"></a>——. “The Subjectivity of Happiness.” <i>Journal of Value Inquiry</i> 44, no. 1 (2010): 47–54.</div>
<div class="indent">——. “Meaningful Lives.” <i>Ratio</i> 26, no. 1 (2013): 79–90.</div>
<div class="indent">——. “Meaningful Lives?” In <i>Exploring Ethics</i>, edited by Steven M. Cahn, 462–64. 3rd ed. New York: Oxford University Press, 2014.</div>
<div class="indent">Cahn, Steven M., and Christine Vitrano. <i>Happiness: Classic and Contemporary Readings in Philosophy</i>. New York: Oxford University Press, 2008.</div>
<div class="indent">——. “Choosing the Experience Machine.” <i>Philosophy in the Contemporary World</i> 20, no. 1 (2013): 52–58.</div>
<div class="indent">——. “Living Well.” <i>Think</i> 13 (Autumn 2014): 13–23.</div>
<div class="indent">The material from <i>God, Reason and Religion</i> is copyright © 2006 by Wadsworth, a part of Cengage Learning, Inc. Reproduced by permission. <a href="http://www.cengage.com/permissions" target="_blank">www.cengage.com/permissions</a>.</div>
<div class="indent">The selections from <i>Tanakh: The Holy Scriptures</i> are reprinted by permission of the University of Nebraska Press. Copyright © 1985 Jewish Publication Society, Philadelphia.</div>
<div class="noindent1"><span><img alt="image" src="images/star.png"/></span></div>
<div class="noindent">We wish to express appreciation to Wendy Lochner, our editor at Columbia University Press, for her support and guidance. We also wish to thank assistant editor Christine Dunbar, manuscript editor Kathryn Jorge, and other members of the staff of the Press for their generous help.</div>
<div class="indent">We are especially grateful to Robert B. Talisse for his illuminating foreword, and deeply appreciate his kind words.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface.vue?6b847b46